import { NorcoSiteId } from '../../../util/constants';
import { unitType } from '../../../util/unitType';

import * as R from "rambda";

export const unitConversion = (feature, units) => {

    switch (feature) {
        case "MeasuredCorrosionRate":
        case "MeasuredCorossionRate":
        case "TrainedModelPredictedCorrosionRate":
        case "LiveModelCorrosionRate":
            return unitType(units, 'velocity mils');
        case "MeasuredWallThickness_UI":
        case "MeasuredWallThickness":
        case "TrainedModelPredictedWallThickness":
        case "LiveModelWallThickness":
        case "MinimumWallThickness":
            return unitType(units, 'length');
        // case "Viscosity":
        //     return "Viscosity";
        // case "Density":
        //     return "Density";
        // case "DensityLastMonth":
        // case "DensityLastWeek":
        //     return "convertToUnit('" + unitType(units, 'volume') + "'," + feature + ")";
        // case "ViscosityLastMonth":
        //     return "convertToUnit('" + unitType(units, 'square length') + "/s'," + feature + ")";
        // case "NominalVelocity":
        // case "VelocityLastMonth":
        // case "SG_Velocity":

        //     return "convertToUnit('" + unitType(units, 'longlength') + "/s'," + feature + ")";
        // case "PipeDiameter":
        // case "SmokePointm":
        //     return "convertToUnit('" + unitType(units, 'longlength') + "'," + feature + ")";
        // case "Velocity":
        //     return "Velocity_Analysis"
        case "AnilinePointC":
        case "CloudPointC":
        case "FlashPointC":
        case "FreezePointC":
        case "PourPointC":
        case "SofteningPointC":
        case "Temperature":
        case "TemperatureLastWeek":
        case "NominalTemperature":
        case "HCU_Temperature":
        case "HCU_Fractionator_Temp":
        case "HCU_H2_tube_temp":
        case "HCU_Water_Pump_Temp":
        case "HCU_Outlet_Temp":
        case "HCU_Reactor_Temp":
        case "HCU_Heater_Outlet_temp":
        case "HCU_Stack_Temp_B":
        case "HCU_Tubeskin_temp":
        case "HCU_Lean_Amine_A":
        case "HCU_Lean_Amine_B":
        case "HCU_Stack_Temp_A":
        case "HCU_REAC_Outlet_Temp":
        case "HCU_HPS_Temp":
        case "HCU_Skin_Temp":
        case "HCU_Feed_Outlet_temp":
        case "HCU_Feed_Drum_Temp":
        case "HCU_Heater_stack_temp":
        case "HCU_Preheat_Temp":
        case "HCU_Temp_Bottoms_A":
        case "HCU_Temp_Bottoms_B":
        case "HCU_Feed_Inlet_temp_Frac":
        case "HCU_Frac_Dew_Point":
        case "HCU_NH4Cl_Rate":
        case "AmbientTemp":
        case "DewPoint":
        case "DeltaT":
        case "CC_Temperature":
        case "Dew_Point":
        case "MinCUITemperature":
        case "MaxCUITemperature":
            return unitType(units, 'temperature')
        case "Pressure":
        case "NominalPressure":
        case "ReidVapourPressurePsi":
        case "SG_Pressure":
        case "HCU_H2_Partial_Pressure":
        case "HCU_Tube_Side_dP":
            return unitType(units, 'pressure')
        default:
            return "dimensionless";
    }
};

export const featureConversion = (feature, site, units) => {

    const isRhienland = site === "D014 (RRN)" || site === "D015 (RRS)" ? true : false;

    switch (feature) {
        case "MeasuredCorrosionRate":
        case "MeasuredCorossionRate":
            return "convertToUnit('" + unitType(units, 'velocity mils') + "',MeasuredCorrosionRate)";
        case "TrainedModelPredictedCorrosionRate":
            return "convertToUnit('" + unitType(units, 'velocity mils') + "',TrainedModelPredictedCorrosionRate)";
        case "MeasuredWallThickness_UI":
            if (isRhienland) {
                return "convertToUnit('" + unitType(units, 'length') + "',RHE_MeasuredWallThickness_UI)";
            } else {
                return "convertToUnit('" + unitType(units, 'length') + "',MeasuredWallThickness_UI)";
            }
        case "TrainedModelPredictedWallThickness":
            return "convertToUnit('" + unitType(units, 'length') + "',TrainedModelPredictedWallThickness)";
        case "LiveModelPredictedCorrosionRate":
            return "convertToUnit('" + unitType(units, 'velocity mils') + "',LiveModelPredictedCorrosionRate)";
        case "LiveModelPredictedWallThickness":
            if (isRhienland) {
                return "convertToUnit('" + unitType(units, 'length') + "',LiveModelPredictedWallThickness_RHE)";
            } else {
                return "convertToUnit('" + unitType(units, 'length') + "',LiveModelPredictedWallThickness)";
            }
        case "MinimumWallThickness":
            return "convertToUnit('" + unitType(units, 'length') + "',MinimumWallThickness)";
        case "Viscosity":
            return "Viscosity";
        case "Density":
            return "Density";
        case "DensityLastMonth":
        case "DensityLastWeek":
            return "convertToUnit('" + unitType(units, 'volume') + "'," + feature + ")";
        // case "HCU_Water_Wash_Flow_Rate":
        // case "HCU_Water_Inj_Rate":
        //     return "convertToUnit('" + unitType(units, 'volume') + "/min'," + feature + ")";
        // case "HCU_Inorganic_Chloride":
        //     return "convertToUnit('mg/" + unitType(units, 'volume') + "'," + feature + ")";
        // case "HCU_Hydrogen_Flow":
        // case "HCU_H2_Flow":
        //     return "convertToUnit('" + unitType(units, 'cubic length') + "/day'," + feature + ")";
        // case "Throughput":
        //     return "convertToUnit('" + unitType(units, 'cubic length') + "/h'," + feature + ")";
        case "ViscosityLastMonth":
            return "convertToUnit('" + unitType(units, 'square length') + "/s'," + feature + ")";
        case "NominalVelocity":
        case "VelocityLastMonth":
        case "SG_Velocity":

            return "convertToUnit('" + unitType(units, 'longlength') + "/s'," + feature + ")";
        case "PipeDiameter":
        case "SmokePointm":
            return "convertToUnit('" + unitType(units, 'longlength') + "'," + feature + ")";
        case "Velocity":
            return "Velocity_Analysis"
        case "AnilinePointC":
        case "CloudPointC":
        case "FlashPointC":
        case "FreezePointC":
        case "PourPointC":
        case "SofteningPointC":
        case "Temperature":
        case "TemperatureLastWeek":
        case "NominalTemperature":
        case "HCU_Temperature":
        case "HCU_Fractionator_Temp":
        case "HCU_H2_tube_temp":
        case "HCU_Water_Pump_Temp":
        case "HCU_Outlet_Temp":
        case "HCU_Reactor_Temp":
        case "HCU_Heater_Outlet_temp":
        case "HCU_Stack_Temp_B":
        case "HCU_Tubeskin_temp":
        case "HCU_Lean_Amine_A":
        case "HCU_Lean_Amine_B":
        case "HCU_Stack_Temp_A":
        case "HCU_REAC_Outlet_Temp":
        case "HCU_HPS_Temp":
        case "HCU_Skin_Temp":
        case "HCU_Feed_Outlet_temp":
        case "HCU_Feed_Drum_Temp":
        case "HCU_Heater_stack_temp":
        case "HCU_Preheat_Temp":
        case "HCU_Temp_Bottoms_A":
        case "HCU_Temp_Bottoms_B":
        case "HCU_Feed_Inlet_temp_Frac":
        case "HCU_Frac_Dew_Point":
        case "HCU_NH4Cl_Rate":
        case "AmbientTemp":
        case "DewPoint":
        case "DeltaT":
            if (site === NorcoSiteId) {
                return units ? "convertToUnit('degrees_fahrenheit'," + feature + ")" : feature;
            } else {
                return "convertToUnit('" + unitType(units, 'temperature') + "', " + feature + ")";
            }

        case "CC_Temperature":
        case "Dew_Point":
            if (site === NorcoSiteId) {
                return units ? "convertToUnit('degrees_fahrenheit'," + feature + ")" : feature;
            } else {
                return "convertToUnit('" + unitType(units, 'temperature') + "'," + feature + ")";
            }

        case "MinCUITemperature":
            return `convertToUnit('${unitType(units, 'temperature')}',treatAsUnit('degrees_celcius',MinCUITemperature))`;
        case "MaxCUITemperature":
            return `convertToUnit('${unitType(units, 'temperature')}',treatAsUnit('degrees_celcius',MaxCUITemperature))`;
        case "Pressure":
        case "NominalPressure":
        case "ReidVapourPressurePsi":
        case "SG_Pressure":
        case "HCU_H2_Partial_Pressure":
        case "HCU_Tube_Side_dP":
            if (site === NorcoSiteId) {
                return units ? "convertToUnit('psig'," + feature + ")" : feature;
            } else {
                return "convertToUnit('" + unitType(units, 'pressure') + "'," + feature + ")";
            }

        default:
            return feature;
    }

};

export const digitsBasedOnUnits = (units) => {
    if (units) {
        return 5;
    }
    else return 3;
}

export const changeZeroToNull = (chartData) => {
    Object.keys(chartData.result).forEach((id) => {
        Object.keys(chartData.result[id]).forEach((element) => {
            const data_List = R.path(["result", id, element, "data"], chartData);
            const missing = R.path(["result", id, element, "missing"], chartData);
            data_List?.forEach((item, index) => {
                if (item === 0 && missing[index] > 0) {
                    data_List[index] = null;
                }
            });
            chartData.result[id][element].data = data_List;
        });
    });
    return chartData;
};

export const medianValue = (values) => {
    values.sort(function (a, b) {
        return a - b;
    });
    var half = Math.floor(values.length / 2);
    if (values.length % 2)
        return values[half];
    return (values[half - 1] + values[half]) / 2.0;
};

export const calculateStatisticsForSubjects = (metricData, type, isNorco, unit, featureList, passedSubjects) => {

    var statisticsValuesForSubjects = [];
    if (metricData !== undefined) {
        Object.keys(metricData.result).forEach((id) => {
            Object.keys(metricData.result[id]).forEach((feature) => {
                const values = metricData.result[id][feature].data;
                const featureData = featureList.find(el => feature === el.id);
                const featureName = !featureData ? '' : featureData?.name;

                const data = values?.filter(values => values !== null);
                var average = [];
                var standardDeviation = [];
                var standardError = [];
                var median = [];
                var min = [];
                var max = [];
                if (data !== undefined) {
                    const averageTemp = data.reduce((a, b) => a + b, 0) / data.length;
                    average = averageTemp;
                    standardDeviation = Math.sqrt(data.map(x => Math.pow(x - averageTemp, 2)).reduce((a, b) => a + b, 0) / data.length);
                    standardError = standardDeviation / Math.sqrt(data.length);
                    median = medianValue(data);
                    min = Math.min.apply(Math, data);
                    max = Math.max.apply(Math, data);
                }
                statisticsValuesForSubjects.push({
                    type: type,
                    id: id,
                    feature: featureName,
                    average: average,
                    standardDeviation: standardDeviation,
                    standardError: standardError,
                    median: median,
                    min: min,
                    max: max,
                    shortname: passedSubjects.find(x => x.name === id)?.shortname,
                });
            });
        });
    }
    return statisticsValuesForSubjects;
};



export const calculateStatistics = (sensorData, cmlData, unit, featureList, passedSubjects) => {
    let statisticsValues = [];
    statisticsValues = statisticsValues.concat(
        calculateStatisticsForSubjects(sensorData, "Sensor", '', unit, featureList, passedSubjects),
        calculateStatisticsForSubjects(cmlData, "CML", '', unit, featureList, passedSubjects)
    );
    return statisticsValues;
};



export const getName = (name) => {
    switch (name) {
        case "MeasuredWallThickness":
            return "Measured wall thickness";
        case "MeasuredCorrosionRate":
            return "Measured corrosion rate";
        case "MinimumWallThickness":
            return "Minimum Required wall thickness";
        case "LiveModelWallThickness":
            return "Predicted wall thickness";
        case "LiveModelCorrosionRate":
            return "Predicted corrosion rate";
        case "DewPoint":
            return `Aqueous dew point (overhead vapors)`;
        case "DeltaT":
            return `TCR vs. aq. dew point (overhead vapors)`
        case "TanMgKOHg":
        case "HCU_Naphthenic_Acid":
            return `${name}[mgKOH/g]`;
        case "HCU_Water_Wash_Flow_Rate":
        case "HCU_Water_Inj_Rate":
        case "HCU_Oil_Flow":
        case "HCU_Naptha_Flow":
            return `${name}[Mbbl/day]`;
        case "HCU_Nitrogen":
        case "HCU_Total_Nitrogen":
            return `${name}[ppm]`;
        case "HCU_Rich_Amine":
            return `${name}`;
        case "HCU_Sour_H2O_Chlorides":
            return `${name}[mg/L]`;
        case "SG_H2S":
            return `${name}[PPBV]`;
        case "NaClContent":
        case "ChlorideContent":
        case "NaOHConc":
        case "NH4Content":
        case "FEContent":
            return `${name}[ppmw]`
        case "AmineDosingRate":
            return `${name}[l/h]`
        case "H2OContent":
            return `${name}[wt%]`
        case "Sulphur_O3":
            return "Residual_S03"
        case "DISS_O":
            return "Dissolved Oxygen"
        case "Water":
            return "Prod_Injectedwater/day"
        case "Liquid":
            return "Oxy-Scav_LPD"
        default:
            return name;
    }
};


export const generateAnalysisSummary = (analysisStatistics, context, metricData) => {
    return analysisStatistics?.map((statistic) => {
        // Find the matching metricData object
        const matchingMetric = metricData.find(
            (metric) => metric.id === statistic.id && metric.featureName === statistic.feature
        );
        // Extract the color, default to a fallback color if not found
        const color = matchingMetric ? matchingMetric.line.color : '#ccc'; // Assuming #ccc as a fallback color

        return {
            type: statistic.type,
            id: statistic.id,
            name: statistic.type === 'CML' ? statistic.shortname : statistic.id,
            feature: statistic.feature,
            average: statistic.average.toFixed(digitsBasedOnUnits(context.units)).replace('NaN', 0),
            standardDeviation: statistic.standardDeviation.toFixed(digitsBasedOnUnits(context.units)).replace('NaN', 0),
            standardError: statistic.standardError.toFixed(digitsBasedOnUnits(context.units)).replace('NaN', 0),
            median: statistic.median.toFixed(digitsBasedOnUnits(context.units)).replace('NaN', 0),
            min: statistic.min.toFixed(digitsBasedOnUnits(context.units)).replace('-Infinity', 0).replace('Infinity', 0),
            max: statistic.max.toFixed(digitsBasedOnUnits(context.units)).replace('-Infinity', 0).replace('Infinity', 0),
            color, // Include the color for the legend
        };
    });
};